import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { ComponentInterface } from '../../../../../fc-core/src/component-interface';
import { pluckNumber } from '../../../../../fc-core/src/lib';
var UNDEF,
    math = Math,
    mathMin = math.min,
    mathMax = math.max,
    mathAbs = math.abs;

var ColumnMultiSeriesgroup =
/*#__PURE__*/
function (_ComponentInterface) {
  _inherits(ColumnMultiSeriesgroup, _ComponentInterface);

  function ColumnMultiSeriesgroup() {
    var _this;

    _classCallCheck(this, ColumnMultiSeriesgroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ColumnMultiSeriesgroup).call(this)), _this.setState('visible', !0);
    return _this;
  }

  _createClass(ColumnMultiSeriesgroup, [{
    key: "getType",
    value: function getType() {
      return 'group';
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'columnMultiSeriesgroup';
    }
  }, {
    key: "preConfigure",
    value: function preConfigure(a) {
      return !!a && void (this.config.JSONData = a, _get(_getPrototypeOf(ColumnMultiSeriesgroup.prototype), "preConfigure", this).call(this, a));
    }
  }, {
    key: "configure",
    value: function configure(a) {
      return !!a && void _get(_getPrototypeOf(ColumnMultiSeriesgroup.prototype), "configure", this).call(this, a);
    }
  }, {
    key: "setVisibility",
    value: function setVisibility() {
      var a = this,
          b = 0;
      a._mapChildren(function (a) {
        a.setVisibility && a.setVisibility();
      }), a._mapChildren(function (a) {
        a.getState('visible') && b++;
      }), a.setState('visible', !!b);
    }
  }, {
    key: "createContainer",
    value: function createContainer() {
      var a,
          b,
          c = this,
          d = c.getFromEnv('animationManager'),
          e = c.getLinkedParent(),
          f = e.getChildContainer();

      for (a in f) {
        b = f[a], c.getChildContainer(a) || c.addChildContainer(a, d.setAnimation({
          el: 'group',
          attr: {
            name: 'manager-' + a
          },
          component: c,
          container: b
        }));
      }
    }
  }, {
    key: "allocatePosition",
    value: function allocatePosition() {
      this.setColumnPosition();
    }
  }, {
    key: "draw",
    value: function draw() {
      this.createContainer();
    }
  }, {
    key: "getCanvasPadding",
    value: function getCanvasPadding() {
      var a,
          b,
          c = this,
          d = {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      };
      return c.setColumnPosition(), c._mapChildren(function (c) {
        for (b in a = !c.getState('removed') && c.getState('visible') && c.getCanvasPadding && c.getCanvasPadding() || {}, a) {
          a.hasOwnProperty(b) && (d[b] = Math.max(a[b], d[b]));
        }
      }), d;
    }
  }, {
    key: "setColumnPosition",
    value: function setColumnPosition() {
      var a,
          b,
          c,
          d,
          e,
          f,
          g,
          h,
          i = this,
          j = i.getFromEnv('chartConfig'),
          k = i.getFromEnv('chart-attrib'),
          l = i.getFromEnv('xAxis'),
          m = i.getFromEnv('numOfColumns'),
          n = j.plotSpacePercent,
          o = mathMax(pluckNumber(n, 20) % 100, 0),
          p = l.getPixel(0),
          q = l.getPixel(1),
          r = i.getFromEnv('chart').isBar ? j.maxBarHeight : j.maxColWidth,
          s = mathAbs(q - p),
          t = j.plotPaddingPercent,
          u = !0,
          v = j.overlapColumns,
          w = 0,
          x = 0;
      i.addToEnv('groupMaxWidth', s), i._mapChildren(function (a) {
        a.getState('removed') || !1 === a.getState('visible') || x++;
      }), i.addToEnv('numOfColumns', x), i.addToEnv('numColDiff', pluckNumber(m - x, 0)), a = (1 - .01 * n) * s || mathMin(s * (1 - 2 * (o / 200)), r * (x || 1)), k.plotspacepercent === UNDEF && a >= j.canvasWidth / 2 && (a = s - r / 2), b = 0 == x ? a : a / x, e = 1 < x ? v || t !== UNDEF ? 0 < t ? b * t / 100 : 0 : 4 : 0, d = mathMin(b - 1, e), i.addToEnv('plotWidth', b - d), c = -(x / 2 * b - b / 2), i._mapChildren(function (a) {
        !a.getState('removed') && a.getState('visible') && (a.addToEnv('shift', c + w * b + d / 2), w++);
      }), h = a / 2, f = p - h, g = q - h, g - (f + a) < 4 && (u = !1), 0 === o && (u = !0), i.addToEnv('isCrisp', u);
    }
  }, {
    key: "childChanged",
    value: function childChanged() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var b,
          c,
          d = this,
          e = d.config,
          f = d.getLinkedParent(),
          g = 0,
          h = d.getState('visible'),
          i = {};
      d._mapChildren(function (a) {
        a.getState('visible') && g++;
      }), d.setState('visible', !!g), h !== !!g && (c = !0), !1 !== a.dataLimitChanged && (b = d.getDataLimits(), (b.min !== e.range.min || b.max !== e.range.max) && (e.range.min = b.min, e.range.max = b.max, i.dataLimitChanged = !0, c = !0)), c ? f.childChanged && f.childChanged(i) : d.asyncDraw();
    }
  }, {
    key: "getAxisValuePadding",
    value: function getAxisValuePadding() {
      var a = Math.max;
      var b = {},
          c = -Infinity,
          d = -Infinity;
      return this._mapChildren(function (e) {
        e.getState('removed') || (b = e.getAxisValuePadding && e.getAxisValuePadding() || {}, c = a(c, b.left || -Infinity), d = a(d, b.right || -Infinity));
      }), c === -Infinity && (c = 0), d === -Infinity && (d = 0), this.config.padding || (this.config.padding = {}, this.config.padding.left = c, this.config.padding.right = d), {
        left: c,
        right: d
      };
    }
  }, {
    key: "getDataLimits",
    value: function getDataLimits(a) {
      var b,
          c = this,
          d = +Infinity,
          e = -Infinity,
          f = 0,
          g = function g(a) {
        e = Math.max(e, a.max), d = Math.min(d, a.min);
      };

      return c._mapChildren(function (c) {
        return c.getState('removed') ? void 0 : !1 === c.getState('visible') ? void (a && (b = c.getDataLimits(a), g(b))) : void (f++, b = c.getDataLimits(a), g(b));
      }), f ? c.setState('visible', !0) : c.setState('visible', !1), this.config.range || (this.config.range = {}, this.config.range.min = this.config.dataMin, this.config.range.max = this.config.dataMax), {
        max: e,
        min: d
      };
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      return !this.isNotVisible;
    }
  }], [{
    key: "getName",
    value: function getName() {
      return 'columnMultiSeriesgroup';
    }
  }]);

  return ColumnMultiSeriesgroup;
}(ComponentInterface);

export default ColumnMultiSeriesgroup;